var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-error-page"},[_c('font-icon',{staticClass:"icon",attrs:{"icon":"fa-solid fa-circle-exclamation","size":"3x"}}),_c('h1',{staticClass:"status"},[_vm._v(" "+_vm._s(_vm.status)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }